import {toast} from 'react-toastify';
const INITIAL_STATE = {
  tutorial: {}
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case "OBTER_TUTORIAL":
      return {...state, tutorial: action.tutorial[0]};
    case "SALVAR_TUTORIAL":
    toast.success("Videos salvos com sucesso!", 5000);
        return {...state, tutorial: action.tutorial};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/TutorialReducer.js